var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconWrapper } from ".";
export const DragIndicatorIcon = React.forwardRef((_a, ref) => {
    var { color = "primary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 20, height: 20, color: color }, otherProps),
        React.createElement("circle", { cx: "6.5", cy: "3", r: "1.5" }),
        React.createElement("circle", { cx: "6.5", cy: "10", r: "1.5" }),
        React.createElement("circle", { cx: "6.5", cy: "17", r: "1.5" }),
        React.createElement("circle", { cx: "13.5", cy: "3", r: "1.5" }),
        React.createElement("circle", { cx: "13.5", cy: "10", r: "1.5" }),
        React.createElement("circle", { cx: "13.5", cy: "17", r: "1.5" })));
});
//# sourceMappingURL=DragIndicator.js.map